import { render, staticRenderFns } from "./bottom_navbar.vue?vue&type=template&id=6ff392c2"
import script from "./bottom_navbar.vue?vue&type=script&lang=js"
export * from "./bottom_navbar.vue?vue&type=script&lang=js"
import style0 from "./bottom_navbar.vue?vue&type=style&index=0&id=6ff392c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports